import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=c8c93fd8"
var script = {}
import style0 from "./comments.vue?vue&type=style&index=0&id=c8c93fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports